import { ApiService } from "./ApiService.js";

// Nombre del modelo de respuestas ("Claude Haiku 5.5"): se pide una vez y se reusa
let _modeloIa = null;

export async function getModeloIa() {
  if (_modeloIa === null) {
    try {
      const resp = await ApiService.get("kb/info");
      _modeloIa = resp?.data?.llm?.nombre || "";
    } catch {
      return ""; // sin etiqueta, y se reintenta en la próxima visita
    }
  }
  return _modeloIa;
}
